import { useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { TableRow, TableCell, MenuItem } from '@mui/material';
// components

import useLocales from 'src/hooks/useLocales';

import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import Iconify from 'src/components/Iconify';
import { TableMoreMenu } from 'src/components/table';
import { IShopInfo } from 'src/@types/Choqorak/MainTables/Shop/Shop';
import { GetCurrencySymbol } from 'src/sections/common/GetCurrencySymbol';
// ----------------------------------------------------------------------

type Props = {
  row: IShopInfo;
  // selected: boolean;
  onEditRow: VoidFunction;
  //onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  index: any;
  handleDetail: VoidFunction;
};

export default function ShopTableRow({ row, onEditRow, handleDetail, onDeleteRow, index }: Props) {
  const {
    shopCode,
    shopStatus,
    electricMeterSerial,
    rentPerMonth,
    blockName,
    floorCode,
    shopType,
    rentCarrencyId,
  } = row;
  const { translate } = useLocales();
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableRow hover>
      <TableCell align="left">{index + 1}</TableCell>
      <TableCell align="left">{shopCode}</TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {shopType}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {electricMeterSerial}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {blockName}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {floorCode}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {rentPerMonth}{' '}
        {rentCarrencyId === 2 ? GetCurrencySymbol('afn') : GetCurrencySymbol('dollar')}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {shopStatus}
      </TableCell>

      <TableCell align="left">
        <TableMoreMenu
          open={openMenu}
          onOpen={handleOpenMenu}
          onClose={handleCloseMenu}
          actions={
            <>
              <PermissionBasedGuard permissions={['Shop-Delete']}>
                <MenuItem
                  onClick={() => {
                    onDeleteRow();
                    handleCloseMenu();
                  }}
                  sx={{ color: 'error.main' }}
                >
                  <Iconify icon={'eva:trash-2-outline'} />
                  {translate('CRUD.Delete')}
                </MenuItem>
              </PermissionBasedGuard>
              <PermissionBasedGuard permissions={['Shop-Update']}>
                <MenuItem
                  onClick={() => {
                    onEditRow();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'warning.main' }} icon={'eva:edit-fill'} />
                  {translate('CRUD.Update')}
                </MenuItem>
              </PermissionBasedGuard>

              <PermissionBasedGuard permissions={['Shop-GetDetail']}>
                <MenuItem
                  onClick={() => {
                    handleDetail();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('Employee.Details')}
                </MenuItem>
              </PermissionBasedGuard>
            </>
          }
        />
      </TableCell>
    </TableRow>
  );
}
